__turbopack_context__.v({
  "link": "PersonalDataConfirm-module-scss-module__gt8OLq__link",
  "text": "PersonalDataConfirm-module-scss-module__gt8OLq__text",
});
